var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dv5-slide',{attrs:{"view":_vm.slideContent,"swipe":true,"swipeToSlide":true,"responsive":[
            {
                'breakpoint': 100000,
                'settings': {
                    'slidesToShow': 1,
                    'slidesToScroll': 1,
                    'rows': 1
                }
            },
            {
                'breakpoint': 1920,
                'settings': {
                    'slidesToShow': 1,
                    'slidesToScroll': 1,
                    'rows': 1
                }
            },
            {
                'breakpoint': 1366,
                'settings': {
                    'slidesToShow': 1,
                    'slidesToScroll': 1,
                    'rows': 1
                }
            },
            {
                'breakpoint': 1024,
                'settings': {
                    'slidesToShow': 1,
                    'slidesToScroll': 1,
                    'rows': 1
                }
            },
            {
                'breakpoint': 768,
                'settings': {
                    'slidesToShow': 1,
                    'slidesToScroll': 1,
                    'rows': 1
                }
            } ]},scopedSlots:_vm._u([{key:'slide',fn:function(props){return _c('div',{staticClass:"slide-wrapper",class:props.slideClass},[_c('dv5-slide-component',{attrs:{"view":props.slide}})],1)}}],null,true)})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d94a4ab","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/office/js/components/dashboard-v5/auth/InitialSlide.vue
// module id = ZXWf
// module chunks = 0